import { Button } from "@blueprintjs/core";
import { Omnibar } from "@blueprintjs/select";
import React, { useState } from "react";
import { filterFilm, renderOpd } from "../data/OPD";
import Grafik from "./grafik/Grafik";

const OPDSelect = Omnibar.ofType();

export default function Info({ listOpd }) {
  const [opd, setOpd] = useState();
  const [omni, setOmni] = useState({
    allowCreate: false,
    isOpen: false,
    resetOnSelect: false,
  });

  const handleClick = () => {
    setOmni({ ...omni, isOpen: true });
  };

  const handleClose = () => {
    setOmni({ ...omni, isOpen: false });
  };

  return (
    <React.Fragment>
      <div>
        <React.Fragment>
          <div style={{ textAlign: "center" }}>
            <Button text="Klik Mencari OPD" onClick={handleClick} />
            {/* {" or press "}
            <KeyCombo combo="shift + o" /> */}
          </div>
          <OPDSelect
            {...omni}
            items={listOpd}
            itemRenderer={renderOpd}
            itemPredicate={filterFilm}
            onItemSelect={(opd) => {
              setOpd(opd);
              setOmni({ ...omni, isOpen: false });
            }}
            onClose={handleClose}
          >
            <Button>{opd?.name}</Button>
          </OPDSelect>
          {opd ? <Grafik opdId={opd.id} name={opd.name} /> : <div></div>}
        </React.Fragment>
      </div>
    </React.Fragment>
  );
}
